module.exports = __webpack_public_path__ + "site/img/19.62bc0522.jpg";